
  import { computed, defineComponent } from 'vue'
  import { useStore } from 'vuex'
  import RightPanel from '@/components/RightPanel/index.vue'
  import { AppMain, Navbar, Settings, Sidebar, TagsView } from './components'
  import useResize from './hooks/useResize'
  
  export default defineComponent({
    name: 'Layout',
    components: {
      AppMain,
      Navbar,
      RightPanel,
      Settings,
      Sidebar,
      TagsView
    },
    setup() {
      const store = useStore()
      
      // 使用resize hook代替mixin
      useResize()
      
      const theme = computed(() => store.state.settings.theme)
      const sideTheme = computed(() => store.state.settings.sideTheme)
      const sidebar = computed(() => store.state.app.sidebar)
      const device = computed(() => store.state.app.device)
      const needTagsView = computed(() => store.state.settings.tagsView)
      const fixedHeader = computed(() => store.state.settings.fixedHeader)
      
      const classObj = computed(() => {
        return {
          hideSidebar: !sidebar.value.opened,
          openSidebar: sidebar.value.opened,
          withoutAnimation: sidebar.value.withoutAnimation,
          mobile: device.value === 'mobile'
        }
      })
      
      const handleClickOutside = () => {
        store.dispatch('app/closeSideBar', { withoutAnimation: false })
      }
      
      return {
        theme,
        sideTheme,
        sidebar,
        device,
        needTagsView,
        fixedHeader,
        classObj,
        handleClickOutside
      }
    }
  })
  